module.exports = __webpack_public_path__ + "img/product_52.e0c036d.webp";